<template>
  <div class="cart-product bg-white bd-radius-5 p-0">
    <b-tabs card class="tab-courier">
      <b-tab title active class="py-3" @click="changeCourier">
        <template v-slot:title>
          <div class="my-2 h3 px-1">
            บริการขนส่ง
          </div>
        </template>
        <SelectCourier ref="selectCourier" @fnGetPosRecentlyList="fnGetPosRecentlyList" :showCart="showCart" :cashNumberInfo="cashNumberInfo" :agentInfo="agentInfo"></SelectCourier>
      </b-tab>
      <b-tab class="py-3"  @click="changeCommodity">
        <template v-slot:title>
          <div class="my-2 h3 px-1">สินค้า</div>
        </template>
        <TabCategoryItem
            :showCart="showCart"
            :cart="cart"
            @fnGetPosRecentlyList="fnGetPosRecentlyList"
            ref="categoryItem"
            :idOrder="idorder"
            :busy.sync="busy"
            :addToCart="addToCart"
        />
<!--        <SelectCommodity ref="SelectCommodity" @fnGetPosRecentlyList="fnGetPosRecentlyList"></SelectCommodity>-->
      </b-tab>
      <b-tab class="py-3">
        <template v-slot:title>
          <div class="my-2 h3 px-1">บริการเสริม</div>
        </template>
        <TabCategoryService
            :showCart="showCart"
            :cart="cart"
            :idOrder="idorder"
            :tmpService="tmpService"
            @fnGetPosRecentlyList="fnGetPosRecentlyList"
            :insuranceService="insuranceService"
            :zendai="zendai"
            :permission="permission"
            @openModal="openModal($event, $event)" @openModalService="openModalService()"
        />
      </b-tab>
    </b-tabs>
    <span class="tags-top-right">
      <b-badge
          v-if="sender.name != '' && sender.identity == false"
          variant="success"
      >
          ยืนยันตัวตนแล้ว
      </b-badge>
      <b-badge
          v-else-if="sender.identity"
          variant="success"
      >
          ยืนยัน COD แล้ว
      </b-badge>
      <b-badge v-else variant="warning">ไม่ได้ยืนยันตัวตน</b-badge>
    </span>
  </div>
</template>
<script>
import SelectCourier from "@/views/Pos/components/SelectCourier.vue";
// import SelectCommodity from "@/views/Pos/components/SelectCommodity.vue";
import TabCategoryItem from "@/views/Pos/components/TabCategoryItem.vue";
import TabCategoryService from "@/views/Pos/components/TabCategoryService.vue";

export default {
  components: {
    TabCategoryService, TabCategoryItem,
    // SelectCommodity,
    SelectCourier},
  props:{
    showCart:{
      type:String,
      default:'',
    },
    agentInfo:{
      type:Object,
      default:() => {},
    },
    cashNumberInfo:{
      type:Object,
      default:() => {},
    },
  },
  data(){
    return {
      sender:{
        name:'',
        identity:'',
      },
      busy:false,
      idorder: "",
      cart: [],
      tmpService: {
        categoryCode: "",
        categoryName: "",
        step: "FIRST",
        code: "",
        name: "",
        rate: "",
        fee: "",
        remark: ""
      },
      insuranceService: {
        show: false,
        insurance: null,
      },
      zendai: {
        show: false,
        zendai: {
          rate: 0
        }
      },
      permission: {
        lineBooking: false,
        dropoffShippop: false,
        interParcelService: false,
        dropoffVRich: false,
        dropoffPanPan: false,
        dropoffEasyShip: false,
        kerryDropoff: false,
        lazadaDropoff: false,
        dropoffQuick: false,
        orangeDropoff: false,
        flashDropoff: false
      },
    }
  },
  methods:{
    fnGetPosRecentlyList(key) {
      this.$emit('fnGetPosRecentlyList')
    },
    changeCourier(){
      this.$refs.selectCourier.getExpressList()
    },
    changeCommodity(){
      this.$refs.categoryItem.getCommodityCategoryList()
    },
    addToCart(){

    },
    // 添加服务
    addServiceNew(item){
      console.log(item)
    },
    openModal(){

    },
    openModalService(){

    }
  }
}
</script>
